// src/vocabulary/A1/unit1/questions.js

const questions = [
  {
    id: 1,
    type: "choice",
    question: "What is the meaning of 'book'?",
    options: ["كرسي", "كتاب", "هاتف"],
    correctAnswer: "كتاب"
  },
  {
    id: 2,
    type: "choice",
    question: "Which word means 'هاتف'?",
    options: ["chair", "phone", "book"],
    correctAnswer: "phone"
  }
];

export default questions;


